import React, { useState } from 'react';
import { 
  FaCookie, 
  FaShieldAlt, 
  FaCheckCircle,
  FaChartLine,
  FaCogs,
  FaBullhorn,
  FaUserLock,
  FaChrome,
  FaFirefox,
  FaSafari,
  FaEdge,
  FaExclamationTriangle,
  FaToggleOn,
  FaInfoCircle
} from 'react-icons/fa';
import Footer from '../components/Footer';
import Header from '../components/Header';

const Cookies = () => {
  const [activeSection, setActiveSection] = useState(null);

  const cookieTypes = [
    {
      id: 1,
      icon: FaCogs,
      title: "Cookies Techniques de Navigation",
      color: "#0d6efd",
      description: "Essentiels au fonctionnement du site",
      content: `Les cookies techniques sont utilisés tout au long de la navigation. Ils sont soit strictement nécessaires à la fourniture du site, soit permettent de faciliter et d'exécuter certaines fonctions sur le site.

**Fonctionnalités :**
• Enregistrement du type et de la version de votre navigateur
• Mémorisation des dates et heures de visite
• Sauvegarde des identifiants de connexion
• Historique et contenu des commandes (y compris les achats non finalisés)

**Avantage :** Lors de vos prochaines connexions, vous n'avez plus besoin de saisir certaines informations une nouvelle fois.`
    },
    {
      id: 2,
      icon: FaChartLine,
      title: "Cookies de Mesure d'Audience",
      color: "#198754",
      description: "Pour améliorer votre expérience",
      content: `Les cookies de mesure d'audience nous permettent d'améliorer continuellement notre site web.

**Fonctionnalités :**
• Établissement de statistiques de fréquentation
• Évaluation de l'ergonomie du site
• Détection des problèmes de navigation
• Organisation et optimisation des contenus

Ces données nous aident à mieux comprendre comment les visiteurs utilisent notre site et à améliorer leur expérience.`
    },
    {
      id: 3,
      icon: FaBullhorn,
      title: "Cookies Publicitaires",
      color: "#fd7e14",
      description: "Pour des contenus personnalisés",
      content: `Les cookies publicitaires permettent de reconnaître un utilisateur qui revient sur le site ou consulte un autre site internet.

**Fonctionnalités :**
• Suivi des visiteurs à travers le site web
• Affichage de publicités pertinentes et intéressantes
• Personnalisation du contenu publicitaire

**Services tiers :**
Des partenaires (régies publicitaires, réseaux sociaux, services de retargeting ou d'analyse comportementale) peuvent également utiliser des cookies pour analyser les performances ou permettre un ciblage adapté des publicités.`
    }
  ];

  const browsers = [
    {
      id: 1,
      icon: FaEdge,
      name: "Internet Explorer / Edge",
      color: "#0078d4",
      steps: [
        "Cliquez sur le bouton Outils, puis sur Options Internet",
        "Sous l'onglet Général, sous Historique de navigation, cliquez sur Paramètres",
        "Cliquez sur le bouton Afficher les fichiers",
        "Cliquez sur l'en-tête de colonne Nom pour trier les fichiers alphabétiquement",
        "Recherchez les fichiers commençant par le préfixe « Cookie »",
        "Sélectionnez les cookies contenant le nom « CINEF » et supprimez-les",
        "Fermez la fenêtre et cliquez deux fois sur OK"
      ]
    },
    {
      id: 2,
      icon: FaFirefox,
      name: "Mozilla Firefox",
      color: "#ff7139",
      steps: [
        "Allez dans le menu Outils du navigateur",
        "Sélectionnez le menu Options",
        "Dans la fenêtre qui s'affiche, choisissez « Vie privée et sécurité »",
        "Cliquez sur « Gérer les données »",
        "Repérez les fichiers qui contiennent le nom « CINEF »",
        "Sélectionnez-les et supprimez-les"
      ]
    },
    {
      id: 3,
      icon: FaSafari,
      name: "Safari",
      color: "#006cff",
      steps: [
        "Dans votre navigateur, choisissez le menu Édition > Préférences",
        "Cliquez sur Sécurité",
        "Cliquez sur Afficher les cookies",
        "Sélectionnez les cookies qui contiennent le nom « CINEF »",
        "Cliquez sur Effacer ou sur Tout effacer",
        "Après avoir supprimé les cookies, cliquez sur Terminé"
      ]
    },
    {
      id: 4,
      icon: FaChrome,
      name: "Google Chrome",
      color: "#4285f4",
      steps: [
        "Cliquez sur l'icône du menu Outils (trois points verticaux)",
        "Sélectionnez Paramètres",
        "Cliquez sur Confidentialité et sécurité",
        "Sélectionnez Cookies et autres données de sites",
        "Cliquez sur Afficher tous les cookies et données de sites",
        "Recherchez « CINEF » et supprimez les entrées correspondantes"
      ]
    }
  ];

  return (
    <>
      <Header />
      <div className="cookies-wrapper">
        {/* Hero Section */}
        <section className="cookies-hero">
          <div className="container">
            <div className="hero-content">
              <div className="hero-badge">
                <FaCookie className="badge-icon" />
                <span>Politique des Cookies</span>
              </div>
              <h1 className="hero-title">
                Gestion des 
                <span className="gradient-text">cookies</span>
              </h1>
              <p className="hero-description">
                Les cookies nous permettent de personnaliser votre expérience sur www.cinef-bj.com, 
                d'analyser le trafic et d'améliorer nos services. Découvrez comment nous les utilisons 
                et comment les gérer selon vos préférences.
              </p>
              <div className="hero-info">
                <div className="info-item">
                  <FaCheckCircle />
                  <span>Transparence totale</span>
                </div>
                <div className="info-item">
                  <FaToggleOn />
                  <span>Contrôle utilisateur</span>
                </div>
                <div className="info-item">
                  <FaShieldAlt />
                  <span>Données sécurisées</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Introduction Section */}
        <section className="intro-section">
          <div className="container">
            <div className="intro-card">
              <div className="intro-icon">
                <FaInfoCircle />
              </div>
              <div className="intro-content">
                <h3>Qu'est-ce qu'un cookie ?</h3>
                <p>
                  Les cookies sont de petits fichiers texte stockés sur votre appareil lors de votre 
                  navigation sur notre site. Ils permettent d'optimiser votre expérience, d'offrir des 
                  fonctionnalités relatives aux médias sociaux et d'analyser le trafic. Des informations 
                  sur votre utilisation du site peuvent être partagées avec nos partenaires de médias 
                  sociaux, de publicité et d'analyse.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Cookie Types Section */}
        <section className="cookie-types-section">
          <div className="container">
            <div className="section-header">
              <h2>Types de Cookies Utilisés</h2>
              <p>Nous utilisons trois catégories principales de cookies sur notre site</p>
            </div>
            
            <div className="cookie-types-grid">
              {cookieTypes.map((cookie) => {
                const Icon = cookie.icon;
                const isActive = activeSection === cookie.id;
                
                return (
                  <div 
                    key={cookie.id}
                    className={`cookie-type-card ${isActive ? 'active' : ''}`}
                    onClick={() => setActiveSection(isActive ? null : cookie.id)}
                  >
                    <div className="card-header">
                      <div className="card-icon" style={{ background: cookie.color }}>
                        <Icon />
                      </div>
                      <div className="card-title-section">
                        <h3>{cookie.title}</h3>
                        <p className="card-description">{cookie.description}</p>
                      </div>
                    </div>
                    
                    {isActive && (
                      <div className="card-content">
                        {cookie.content.split('\n\n').map((paragraph, idx) => {
                          // Check if paragraph starts with **
                          if (paragraph.startsWith('**')) {
                            const [title, ...content] = paragraph.split('\n');
                            return (
                              <div key={idx} className="content-block">
                                <h4>{title.replace(/\*\*/g, '')}</h4>
                                {content.map((line, lineIdx) => (
                                  <p key={lineIdx}>{line}</p>
                                ))}
                              </div>
                            );
                          }
                          return <p key={idx}>{paragraph}</p>;
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Preference Section */}
        <section className="preference-section">
          <div className="container">
            <div className="preference-card">
              <div className="preference-icon">
                <FaUserLock />
              </div>
              <div className="preference-content">
                <h2>Vos Préférences</h2>
                <p>
                  Pour bénéficier de l'ensemble des fonctionnalités du site, il est préférable 
                  d'accepter tous les cookies. Toutefois, vous pouvez vous opposer à l'enregistrement 
                  de certains cookies en paramétrant directement votre navigateur internet.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Browser Configuration Section */}
        <section className="browser-config-section">
          <div className="container">
            <div className="section-header">
              <h2>Paramétrage des Navigateurs</h2>
              <p>Suivez ces instructions pour gérer les cookies dans votre navigateur</p>
            </div>
            
            <div className="browsers-grid">
              {browsers.map((browser) => {
                const Icon = browser.icon;
                const isActive = activeSection === `browser-${browser.id}`;
                
                return (
                  <div 
                    key={browser.id}
                    className={`browser-card ${isActive ? 'active' : ''}`}
                    onClick={() => setActiveSection(isActive ? null : `browser-${browser.id}`)}
                  >
                    <div className="browser-header">
                      <div className="browser-icon" style={{ color: browser.color }}>
                        <Icon />
                      </div>
                      <h3>{browser.name}</h3>
                    </div>
                    
                    {isActive && (
                      <div className="browser-steps">
                        <ol>
                          {browser.steps.map((step, idx) => (
                            <li key={idx}>{step}</li>
                          ))}
                        </ol>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Warning Section */}
        <section className="warning-section">
          <div className="container">
            <div className="warning-card">
              <div className="warning-icon">
                <FaExclamationTriangle />
              </div>
              <div className="warning-content">
                <h3>Note importante</h3>
                <p>
                  La désactivation de certains cookies peut limiter votre expérience sur notre site 
                  et empêcher l'accès à certaines fonctionnalités. Nous vous recommandons de maintenir 
                  les cookies techniques activés pour une navigation optimale.
                </p>
              </div>
            </div>
          </div>
        </section>

       

        <style>{`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          .cookies-wrapper {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
            color: #1a202c;
            background: #ffffff;
          }

          .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
          }

          /* Hero Section */
          .cookies-hero {
            background: linear-gradient(135deg, #fff5e6 0%, #ffffff 100%);
            padding: 100px 0 80px;
            position: relative;
            overflow: hidden;
          }

          .cookies-hero::before {
            content: '';
            position: absolute;
            top: -20%;
            right: -10%;
            width: 500px;
            height: 500px;
            background: radial-gradient(circle, rgba(253, 126, 20, 0.1) 0%, transparent 70%);
            border-radius: 50%;
          }

          .hero-content {
            text-align: center;
            position: relative;
            z-index: 1;
          }

          .hero-badge {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            background: white;
            padding: 10px 24px;
            border-radius: 50px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            margin-bottom: 24px;
            font-size: 14px;
            font-weight: 600;
            color: #fd7e14;
            margin-top: 30px;
          }

          .badge-icon {
            animation: rotate 3s linear infinite;
          
          }

          @keyframes rotate {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }

          .hero-title {
            font-size: 56px;
            font-weight: 900;
            line-height: 1.15;
            color: #1a202c;
            margin-bottom: 20px;
            letter-spacing: -1.5px;
          }

          .gradient-text {
            background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin-left: 8px;
          }

          .hero-description {
            font-size: 18px;
            line-height: 1.7;
            color: #4a5568;
            max-width: 750px;
            margin: 0 auto 32px;
          }

          .hero-info {
            display: flex;
            gap: 32px;
            justify-content: center;
            flex-wrap: wrap;
          }

          .info-item {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 15px;
            color: #718096;
            font-weight: 500;
          }

          .info-item svg {
            color: #198754;
            font-size: 18px;
          }

          /* Introduction Section */
          .intro-section {
            padding: 60px 0;
            background: white;
          }

          .intro-card {
            display: flex;
            gap: 24px;
            padding: 32px;
            background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
            border-radius: 16px;
            border-left: 4px solid #0d6efd;
          }

          .intro-icon {
            width: 48px;
            height: 48px;
            background: white;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0d6efd;
            font-size: 24px;
            flex-shrink: 0;
          }

          .intro-content h3 {
            font-size: 20px;
            font-weight: 700;
            color: #1a202c;
            margin-bottom: 12px;
          }

          .intro-content p {
            font-size: 15px;
            line-height: 1.7;
            color: #4a5568;
          }

          /* Cookie Types Section */
          .cookie-types-section {
            padding: 80px 0;
            background: #fafafa;
          }

          .section-header {
            text-align: center;
            margin-bottom: 50px;
          }

          .section-header h2 {
            font-size: 36px;
            font-weight: 900;
            color: #1a202c;
            margin-bottom: 12px;
          }

          .section-header p {
            font-size: 18px;
            color: #718096;
          }

          .cookie-types-grid {
            display: grid;
            gap: 24px;
          }

          .cookie-type-card {
            background: white;
            border-radius: 16px;
            border: 2px solid #e2e8f0;
            overflow: hidden;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .cookie-type-card:hover {
            border-color: #fd7e14;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
          }

          .cookie-type-card.active {
            border-color: #fd7e14;
            box-shadow: 0 12px 32px rgba(253, 126, 20, 0.15);
          }

          .card-header {
            display: flex;
            align-items: flex-start;
            gap: 20px;
            padding: 28px 32px;
          }

          .card-icon {
            width: 64px;
            height: 64px;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 28px;
            flex-shrink: 0;
            transition: all 0.3s ease;
          }

          .cookie-type-card:hover .card-icon {
            transform: scale(1.05) rotate(-5deg);
          }

          .card-title-section {
            flex: 1;
          }

          .card-title-section h3 {
            font-size: 20px;
            font-weight: 700;
            color: #1a202c;
            margin-bottom: 8px;
          }

          .card-description {
            font-size: 14px;
            color: #718096;
            margin: 0;
          }

          .card-content {
            padding: 0 32px 28px 116px;
            animation: slideDown 0.3s ease;
          }

          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .content-block {
            margin-bottom: 20px;
          }

          .content-block h4 {
            font-size: 16px;
            font-weight: 700;
            color: #1a202c;
            margin-bottom: 12px;
          }

          .card-content p {
            font-size: 15px;
            line-height: 1.8;
            color: #4a5568;
            margin-bottom: 12px;
          }

          /* Preference Section */
          .preference-section {
            padding: 60px 0;
            background: white;
          }

          .preference-card {
            display: flex;
            gap: 24px;
            padding: 40px;
            background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
            border-radius: 20px;
            align-items: center;
          }

          .preference-icon {
            width: 80px;
            height: 80px;
            background: white;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #9c27b0;
            font-size: 36px;
            flex-shrink: 0;
          }

          .preference-content h2 {
            font-size: 28px;
            font-weight: 900;
            color: #1a202c;
            margin-bottom: 12px;
          }

          .preference-content p {
            font-size: 16px;
            line-height: 1.7;
            color: #4a5568;
          }

          /* Browser Configuration Section */
          .browser-config-section {
            padding: 80px 0;
            background: #fafafa;
          }

          .browsers-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 24px;
          }

          .browser-card {
            background: white;
            border-radius: 16px;
            border: 2px solid #e2e8f0;
            overflow: hidden;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .browser-card:hover {
            border-color: #0d6efd;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
          }

          .browser-card.active {
            border-color: #0d6efd;
            box-shadow: 0 12px 32px rgba(13, 110, 253, 0.15);
          }

          .browser-header {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 24px;
          }

          .browser-icon {
            font-size: 36px;
          }

          .browser-header h3 {
            font-size: 18px;
            font-weight: 700;
            color: #1a202c;
          }

          .browser-steps {
            padding: 0 24px 24px;
            animation: slideDown 0.3s ease;
          }

          .browser-steps ol {
            margin-left: 20px;
          }

          .browser-steps li {
            font-size: 14px;
            line-height: 1.8;
            color: #4a5568;
            margin-bottom: 12px;
          }

          /* Warning Section */
          .warning-section {
            padding: 60px 0;
            background: white;
          }

          .warning-card {
            display: flex;
            gap: 24px;
            padding: 32px;
            background: linear-gradient(135deg, #fff3cd 0%, #ffe5a1 100%);
            border-radius: 16px;
            border-left: 4px solid #ffc107;
          }

          .warning-icon {
            width: 48px;
            height: 48px;
            background: white;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffc107;
            font-size: 24px;
            flex-shrink: 0;
          }

          .warning-content h3 {
            font-size: 20px;
            font-weight: 700;
            color: #1a202c;
            margin-bottom: 12px;
          }

          .warning-content p {
            font-size: 15px;
            line-height: 1.7;
            color: #4a5568;
          }

          /* Contact Section */
          .contact-section {
            padding: 80px 0;
            background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
            position: relative;
            overflow: hidden;
          }

          .contact-section::before {
            content: '';
            position: absolute;
            top: -30%;
            right: -15%;
            width: 600px;
            height: 600px;
            background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
            border-radius: 50%;
          }

          .contact-card {
            position: relative;
            z-index: 1;
          }

          .contact-content {
            text-align: center;
            color: white;
          }

          .contact-icon {
            width: 80px;
            height: 80px;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 36px;
            margin: 0 auto 24px;
            animation: float 3s ease-in-out infinite;
          }

          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }

          .contact-content h2 {
            font-size: 36px;
            font-weight: 900;
            margin-bottom: 16px;
          }

          .contact-content p {
            font-size: 18px;
            line-height: 1.7;
            opacity: 0.95;
            max-width: 650px;
            margin: 0 auto 32px;
          }

          .contact-btn {
            display: inline-block;
            padding: 18px 40px;
            background: white;
            color: #fd7e14;
            border-radius: 12px;
            font-size: 17px;
            font-weight: 700;
            text-decoration: none;
            transition: all 0.3s ease;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
          }

          .contact-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .hero-title {
              font-size: 40px;
            }

            .hero-description {
              font-size: 16px;
            }

            .hero-info {
              flex-direction: column;
              gap: 16px;
            }

            .intro-card,
            .preference-card,
            .warning-card {
              flex-direction: column;
              padding: 24px;
            }

            .card-content {
              padding: 0 24px 24px 24px;
            }

            .browsers-grid {
              grid-template-columns: 1fr;
            }

            .section-header h2 {
              font-size: 28px;
            }

            .contact-content h2 {
              font-size: 28px;
            }

            .contact-content p {
              font-size: 16px;
            }
          }
        `}</style>
      </div>
      <Footer />
    </>
  );
};

export default Cookies;